<script>
    import * as m from '@app/paraglide/messages.js';
    import { eventGroupState, isSelectedEventGroupLocked } from "@app/store/eventGroupStore.svelte.js";
    import { projectState } from "@app/store/projectStore.svelte.js";
    import { insertHistoryAction } from "@app/store/historyStore.svelte.js";
    import { createEventDispatcher } from "svelte";
    import { toast } from "@zerodevx/svelte-toast";
    import removeEvent from "@cclib/functions/eventGroups/removeEvent.js";
    import { getHighlightedDomText, getQuillTextSelection } from "@app/lib/copySelection.js";

    const dispatch = createEventDispatcher();
    let isLocked = $derived(isSelectedEventGroupLocked());

    async function cutEvents() {
        try {
            if (isSelectedEventGroupLocked()) {
                toast.push(m.event_group_locked_toast(), { classes: ["toast-warning"] });
                return;
            }

            if (eventGroupState[projectState.selected].selected.length > 0) {
                const eventGroup = eventGroupState[projectState.selected];
                const quillSelection = getQuillTextSelection(eventGroup);
                if (quillSelection) {
                    quillSelection.editor.deleteText(
                        quillSelection.range.index,
                        quillSelection.range.length,
                    );
                    navigator.clipboard.writeText(quillSelection.text);
                    insertHistoryAction({
                        name: "cut event(s)", //action name
                        eventGroup: projectState.selected,
                        snapshots: [
                            {
                                store: "eventGroupState",
                                value: JSON.stringify(eventGroupState),
                            },
                        ],
                    });
                    return;
                }

                const domText = getHighlightedDomText();
                if (domText) {
                    navigator.clipboard.writeText(domText);
                    return;
                }

                let eventsToCut = [];
                let selectedEvents = eventGroup.selected.map((selectedEvent) => {
                    return selectedEvent;
                });

                eventGroupState[projectState.selected].selected = [];

                selectedEvents
                    .sort((a, b) => {
                        return b - a;
                    })
                    .forEach((eventIndex) => {
                        eventsToCut.push(
                            eventGroupState[projectState.selected].events[
                                eventIndex
                            ],
                        );
                        eventGroupState[projectState.selected] =
                            removeEvent(
                                eventGroupState[projectState.selected],
                                eventIndex,
                            );
                    });

                navigator.clipboard.writeText(JSON.stringify(eventsToCut));

                insertHistoryAction({
                    name: "cut event(s)", //action name
                    eventGroup: projectState.selected,
                    snapshots: [
                        {
                            store: "eventGroupState",
                            value: JSON.stringify(eventGroupState),
                        },
                    ],
                });
            }
        } catch (err) {
            console.log(err);
            console.log(err.message);
        } finally {
            dispatch("done");
        }
    }
</script>

<a id="btnCutEvents"
   role="menuitem"
   aria-label={m.context_menu_cut_label()}
   aria-disabled={isLocked}
   class="dropdown-item" class:disabled={isLocked} href="#!/"
   onclick={cutEvents}>
   {m.context_menu_cut()}
</a>
